import React from 'react';
import { motion } from 'framer-motion';
import {
  Plug,
  Workflow,
  Brain,
  Database,
  Code,
  MapPin
} from 'lucide-react';

const features = [
  {
    icon: Plug,
    title: '600+ коннекторов',
    description: 'Подключайте любой источник за минуты. CRM, базы, SaaS-сервисы, API — всё уже готово.',
    color: 'bg-[#4361ee]'
  },
  {
    icon: Workflow,
    title: 'ETL-пайплайны автоматом',
    description: 'Мы сами строим и поддерживаем ваши пайплайны. Инженеры не нужны.',
    color: 'bg-[#ff6b35]'
  },
  {
    icon: Brain,
    title: 'Инсайты на ИИ',
    description: 'Умные рекомендации и поиск аномалий — из коробки.',
    color: 'bg-[#d4ff00]'
  },
  {
    icon: Code,
    title: 'API-first',
    description: 'Полный программный доступ. Подключайте любую BI-систему или собирайте свои дашборды.',
    color: 'bg-[#e91e63]'
  },
  {
    icon: MapPin,
    title: 'Любой регион',
    description: 'Разворачиваем там, где нужно: Россия, ЕС, США, Азия. Данные остаются в выбранном регионе.',
    color: 'bg-[#00bfa5]'
  },
  {
    icon: Database,
    title: 'Данные принадлежат вам',
    description: 'Уходите — забираете всё. Полная выгрузка вместе со всеми агрегатами.',
    color: 'bg-[#9c27b0]'
  }
];

export default function FeaturesSection() {
  return (
    <section className="bg-black py-24 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-20 h-20 border-4 border-[#d4ff00] rotate-45 opacity-30" />
      <div className="absolute bottom-20 right-20 w-32 h-32 border-4 border-[#ff6b35] rounded-full opacity-20" />

      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-[#d4ff00] text-black px-4 py-2 font-bold text-sm uppercase tracking-wider border-4 border-[#d4ff00] mb-6">
            Всё включено
          </div>
          <h2 className="text-[clamp(1.5rem,8.6vw,2.25rem)] md:text-6xl font-black text-white mb-4">
            Полностью управляемо.
            <br />
            <span className="text-[#d4ff00]">Ноль головной боли.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group bg-white border-4 border-white p-8 shadow-[8px_8px_0_0_#d4ff00] hover:shadow-[12px_12px_0_0_#d4ff00] hover:translate-x-[-4px] hover:translate-y-[-4px] transition-all cursor-default"
            >
              <div className={`w-14 h-14 ${feature.color} border-4 border-black flex items-center justify-center mb-6`}>
                <feature.icon className="w-7 h-7 text-black" />
              </div>
              <h3 className="text-[clamp(1.125rem,5.6vw,1.5rem)] font-black text-black mb-3">{feature.title}</h3>
              <p className="text-black/70 font-medium leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
